import React,{useRef,useState} from 'react'
import intr1 from '../src/images/int4.jpg'
// import intr2 from '../src/images/int2.jpg'
import intr3 from '../src/images/int6.jpg'
import intr4 from '../src/images/int5.jpg'
import intr5 from '../src/images/int1.jpg'
import intr6 from '../src/images/int7.jpg'
import intr7 from '../src/images/int3.jpg'
import intr8 from '../src/images/int8.jpg'
import intr9 from '../src/images/int9.jpg'
import intr10 from '../src/images/int10.jpg'
import intr11 from '../src/images/int11.jpg'
import intr12 from '../src/images/int12.jpg'
import intr13 from '../src/images/int13.jpg'
import intr14 from '../src/images/int14.jpg'
import intr15 from '../src/images/int15.jpg'
import intr16 from '../src/images/int16.jpg'
import intr17 from '../src/images/int17.jpg'
import intr18 from '../src/images/int18.jpg'
import intr19 from '../src/images/int19.jpg'
import intr20 from '../src/images/int20.jpg'
import intr21 from '../src/images/int21.jpg'
import intr22 from '../src/images/int22.jpg'
import intr23 from '../src/images/int23.jpg'
import intr24 from '../src/images/int24.jpg'
import intr25 from '../src/images/int25.jpg'
import intr26 from '../src/images/int26.jpg'
import intr27 from '../src/images/int27.jpg'
import intr28 from '../src/images/int28.jpg'
import intr29 from '../src/images/int29.jpg'
import intr30 from '../src/images/int30.jpg'
import './view.css';
import ArrowRightIcon from '@mui/icons-material/ArrowRight';
import ArrowLeftIcon from '@mui/icons-material/ArrowLeft';


const Interior = () => {
     const [selectedImageIndex, setSelectedImageIndex] = useState(null);
      const scrollRef = useRef(null);
      const images = [
        {src:intr1},
      //  {src:intr2},
        {src:intr3},
        {src:intr8},
       
        {src:intr5},
        {src:intr6},
        {src:intr4},
        // {src:intr7},
       
        // {src:intr9},
        // {src:intr10},
        // {src:intr11},
        // {src:intr12},
     
        // {src:intr14},
        {src:intr13},
        {src:intr15},
        {src:intr16},

        // {src:intr17},
        {src:intr18},
        {src:intr19}, 
        {src:intr20},


        //  {src:intr21}, 
         {src:intr22}, {src:intr23},
        {src:intr24},
        {src:intr25},
        {src:intr26},
        {src:intr27},  {src:intr28},  {src:intr29},  {src:intr30},  

      
       
      ];
      const scrollByAmount = 420 * 3;
      
  const showNextImages = () => {
    if (scrollRef.current) {
      scrollRef.current.scrollBy({ left: scrollByAmount, behavior: 'smooth' });
    }
  };

  const showPrevImages = () => {
    if (scrollRef.current) {
      scrollRef.current.scrollBy({ left: -scrollByAmount, behavior: 'smooth' });
    }
  };
  return (
  <section id="interior" style={{backgroundColor:'rgba(134, 198, 39,0.6)'}}>
     <h4 className="text-center p-3 text-light" style={{position:'relative',top:'30px',left:'0px'}}>Interior</h4> 
<div className="mb-5 mt-0 image-gallery-container">
  <div
    className="image-gallery-container"
    style={{
      display: 'flex',
      position: 'relative',
      top: '40px',
      justifyContent: 'space-between',
    }}
  >
    <button
      className="p-1"
      style={{
        border: '1px solid hsl(255, 93%, 30%)',
        borderRadius: '50px',
        marginLeft: '25px',
      }}
      onClick={showPrevImages}
    >
      <ArrowLeftIcon style={{ color: 'hsl(255, 93%, 30%)', fontSize: '35px' }} />

    </button>
 
    <button
      className="p-1"
      style={{
        border: '1px solid hsl(255, 93%, 30%)',
        borderRadius: '50px',
        marginRight: '45px',
      }}
      onClick={showNextImages}
    >
      <ArrowRightIcon style={{ color: 'hsl(255, 93%, 30%)', fontSize: '35px' }} />
    </button>
  </div>

  <div
    className="image-gallery d-flex"
    ref={scrollRef}
    style={{
      overflowX: 'hidden',
      scrollBehavior: 'smooth',
      gap: '20px',
      marginTop: '20px',
    }}
  >
    {images.map((image, index) => (
      <div key={index} className="gallery-item" style={{ flex: '0 0 auto' }}>
        <img
          
          src={image.src}
          alt="Construction service gallery"
          style={{ height: '400px', width: '400px'}}
        
        />
      </div>
    ))}
  </div>
</div>
{/* <h4 className="text-center text-light p-1" style={{backgroundColor:'rgba(134, 198, 39,0.7)',position:'relative',bottom:'47.5px',left:'0px'}}></h4>  */}


</section>
  )
}

export default Interior
